
export default {
  props: {
    // Number of filled stars
    value: {
      type: Number,
      default: 0,
    },
    // Total number of stars
    length: {
      type: Number,
      default: 5,
    },
    // Disable clicking stars
    readonly: {
      type: Boolean,
      default: false,
    },
    // Font size for stars
    size: {
      type: [Number, String],
      default: 16,
    },
  },
  data() {
    return {
      hovering: 0,
    }
  },
}
